import BundleProductCharacteristic from "../../../entities/manhattan/bundle/BundleProductCharacteristic";
import { IBundleProductCharacteristic } from "../../../entities/manhattan/bundle/types";
import { IManhattanFactory } from "../types";

export const BundleProductCharacteristicFactory: IManhattanFactory = class BundleProductConfigurationFactory {

  static create(productCharacteristic: IBundleProductCharacteristic): BundleProductCharacteristic {
    return new BundleProductCharacteristic(
      productCharacteristic.id,
      productCharacteristic.specificationItemCharacteristic,
      productCharacteristic.value,
      productCharacteristic.valueEn,
      productCharacteristic.characteristicIdentifier,
      productCharacteristic.specificationIdentifier,
      productCharacteristic.specificationItemCharacteristicId,
    );
  }

};

